import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  Typography,
  Button,
  Input,
  InputLabelWrapper,
} from '../../../platform/ui/src/components';

import { LoadingIndicatorProgress } from '@ohif/ui';
import { DicomMetadataStore } from '@ohif/core';
//import { useAppConfig } from '@state';
// import isImportant from '../../utils/isImportant';
import downloadBlob from '../../utils/downloadBlob';
import JSZip from 'jszip';
//import { processCells } from '@kitware/vtk.js/IO/XML/XMLReader';
import guid from '@ohif/core/src/utils/guid';
// import requestDisplaySetCreationForStudy from 'extensions/measurement-tracking/src/panels/PanelStudyBrowserTracking/requestDisplaySetCreationForStudy';

const { requiredTags } = require('../../utils/requiredTags');

const SharedFunctionalGroupsSequenceRequiredItems = {
  MRModifierSequence: [
    'InversionTimes',
    'InversionRecovery',
    'SpectrallySelectedExcitation',
  ],
  MREchoSequence: ['EffectiveEchoTime'],
  MRTimingAndRelatedParametersSequence: ['RepetitionTime'],

  MRImageFrameTypeSequence: [
    'FrameType',
    'PixelPresentation',
    'VolumetricProperties',
  ],
  FrameVOILUTSequence: ['WindowCenter', 'WindowWidth'],
  PixelMeasuresSequence: [
    'SliceThickness',
    // 'SpacingBetweenSlices',
    'PixelSpacing',
  ],
  PlanePositionSequence: ['ImagePositionPatient'],
  PlaneOrientationSequence: ['ImageOrientationPatient'],
};

const PerFrameFunctionalGroupsSequenceRequiredItems = {
  MRImageFrameTypeSequence: [
    'FrameType',
    'PixelPresentation',
    'VolumetricProperties',
  ],
  FrameVOILUTSequence: ['WindowCenter', 'WindowWidth'],
  PixelMeasuresSequence: [
    'SliceThickness',
    // 'SpacingBetweenSlices',
    'PixelSpacing',
  ],
  PlanePositionSequence: ['ImagePositionPatient'],
  PlaneOrientationSequence: ['ImageOrientationPatient'],

  MRModifierSequence: [
    'InversionTimes',
    'InversionRecovery',
    'SpectrallySelectedExcitation',
  ],
  MREchoSequence: ['EffectiveEchoTime'],
  MRTimingAndRelatedParametersSequence: ['RepetitionTime', 'EchoTrainLength'],
};

const UploadForm = ({ onClose, modalService, uiNotificationService }) => {
  const { t } = useTranslation('Modals');

  const [progress, setProgress] = useState(0);
  const [showLoadingIndicator, setShowLoadingIndicator] = useState(false);
  const [progressText, setProgressText] = useState('preparing data');
  const [presharedCode, setPresharedCode] = useState('');

  // https://bobbyhadz.com/blog/react-detect-enter-key-press
  const handleKeyDown = event => {
    // console.log('User pressed: ', event.key);
    if (event.key === 'Enter') {
      uploadStudy();
    }
  };

  function checkValue(inputChar) {
    var regEx = /^[0-9a-zA-Z-_.:/]+$/;

    if (inputChar.match(regEx)) {
      setPresharedCode(inputChar);
    }
  }

  function sendSessionName() {
    const uid = guid();
    console.log('sending guid: ', uid);
    var xhr = new XMLHttpRequest();
    var url = '/api/session/';
    xhr.open('POST', url, true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.onreadystatechange = function() {
      if (xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200) {
        // 4
        // var json = JSON.parse(xhr.responseText);
      }
    };
    var data = JSON.stringify({ guid: uid });
    xhr.send(data);
    console.log('guid sent');
  }

  var uploadBlob = function(file) {
    console.log('uploadBlob');
    setProgressText('uploading data');
    setProgress(0);

    return new Promise((resolve, reject) => {
      const req = new XMLHttpRequest();

      req.upload.addEventListener('progress', event => {
        if (event.lengthComputable) {
          setProgress(Math.round((event.loaded / event.total) * 100));
        }
      });

      req.upload.addEventListener('load', event => {
        resolve(req.response);
      });

      req.upload.addEventListener('error', event => {
        reject(req.response);
      });

      const formData = new FormData();
      formData.append('file', file, file.name);

      req.open('POST', '/api/upload');
      req.send(formData);
    });
  };

  function pscInvalid() {
    return (
      <div className="flex justify-center items-center">
        <p>Please enter at least 5, but no more than 60 characters!</p>
      </div>
    );
  }

  function showPscInvalid() {
    modalService.show({
      content: pscInvalid,
      title: 'Invalid code',
    });
  }

  async function uploadStudy() {
    const studyUIDs = DicomMetadataStore.getStudyInstanceUIDs();

    console.log('upload study, uid:', studyUIDs);

    if (
      (presharedCode.length < 5 && presharedCode.length > 0) ||
      presharedCode.length > 60
    ) {
      console.log('identification code invalid', presharedCode);
      showPscInvalid();
      return;
    }

    for (let studyNo = 0; studyNo < studyUIDs.length; studyNo++) {
      const study = DicomMetadataStore.getStudy(studyUIDs[studyNo]);

      if (!study.Inferenced) {
        if (study.inferable) {
          setShowLoadingIndicator(true);
          setProgressText(`preparing study no. ${studyNo + 1} ...`);

          // https://stackoverflow.com/questions/42453683/how-to-reject-in-async-await-syntax
          try {
            await zipAll(study);
          } catch (error) {
            console.log('zipAll error:', error);
          }
        } else {
          console.log('study not inferable');
          uiNotificationService.show({
            title: 'Analysis not possible',
            message: study.problems,
            // `Serie ${error}_PD_FS or ${error}_T2_STIR is missing, no upload possible!`,
            type: 'warning',
            duration: 8000,
          });
        }
      } else {
        console.log('already inferenced!!!');
      }
    }
    console.log('finished uploading all');
    onClose();
  }

  // https://www.freecodecamp.org/news/check-if-an-object-is-empty-in-javascript/
  const isObjectEmpty = objectName => {
    return (
      objectName &&
      Object.keys(objectName).length === 0 &&
      objectName.constructor === Object
    );
  };

  function zipAll(study) {
    console.log('zipall start'); //, study);

    return new Promise(function(resolve, reject) {
      var foundImportant = false;
      const zip = new JSZip();

      study.series.forEach(serie => {
        if (
          ['PD_FS', 'T2_FS', 'T2_STIR'].includes(serie.Weight[0]) &&
          ['SAG', 'COR', 'AX'].includes(serie.Plane[0])
        ) {
          console.log('zipAll serie:', serie);

          serie.instances.forEach(instance => {
            console.log('zipAll instance:', instance);
            console.log(
              'zipAll instance meta:',
              instance._meta.TransferSyntaxUID.Value[0]
            );

            // úgy tűnik hogy compressed multiframe-nél az egyes képeket külön-külön tárolja arrayban a PixelData alatt, proxy nélkül
            // uncompressed multiframenél fojamatos bytestreamben proxyval, legacynál függetlenül a compressiontól proxyval

            if (
              serie.MultiFrame &&
              (instance._meta.TransferSyntaxUID.Value[0].includes(
                '1.2.840.10008.1.2.4'
              ) ||
                instance._meta.TransferSyntaxUID.Value[0].includes(
                  '1.2.840.10008.1.2.5'
                ))
            ) {
              console.log('study no proxy');
              var imageNo = 0;
              instance.PixelData.forEach(image => {
                imageNo += 1;
                var img_blob = new Blob([image], {
                  type: 'application/dicom',
                });
                zip.file(`${instance.SOPInstanceUID}_${imageNo}.dci`, img_blob);
              });
            } else {
              console.log('study proxy');
              // [0] Proxy miatt!! https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy
              var img_blob = new Blob([instance.PixelData[0]], {
                type: 'application/dicom',
              });
              zip.file(`${instance.SOPInstanceUID}.dci`, img_blob);
            }

            var meta_tags = {};
            meta_tags['tags'] = {};
            meta_tags['file_meta'] = {};

            requiredTags.forEach(tag => {
              meta_tags['tags'][tag] = instance[tag];
            });

            if (instance.SOPClassUID === '1.2.840.10008.5.1.4.1.1.4.1') {
              var tmp = {};
              for (const [key, value] of Object.entries(
                SharedFunctionalGroupsSequenceRequiredItems
              )) {
                console.log('key, value', key, value);
                tmp[key] = {};
                value.forEach(item => {
                  console.log('value', item);

                  try {
                    tmp[key][item] =
                      instance.SharedFunctionalGroupsSequence[0][key][item];
                  } catch (error) {}
                });
                if (isObjectEmpty(tmp[key])) {
                  delete tmp[key];
                }
              }
              console.log('tmp:', tmp);
              meta_tags['tags']['SharedFunctionalGroupsSequence'] = tmp;

              meta_tags['tags']['PerFrameFunctionalGroupsSequence'] = [];

              instance.PerFrameFunctionalGroupsSequence.forEach(sq => {
                var tmp = {};

                for (const [key, value] of Object.entries(
                  PerFrameFunctionalGroupsSequenceRequiredItems
                )) {
                  console.log('key, value', key, value);
                  tmp[key] = {};
                  value.forEach(item => {
                    console.log('value', item);

                    try {
                      tmp[key][item] = sq[key][item];
                    } catch (error) {}
                  });
                  if (isObjectEmpty(tmp[key])) {
                    delete tmp[key];
                  }
                }
                console.log('tmp:', tmp);

                meta_tags['tags']['PerFrameFunctionalGroupsSequence'].push(tmp);
              });
            } else {
              // var meta_tags = {};
              // meta_tags['tags'] = {};
              // meta_tags['file_meta'] = {};
              // requiredTags.forEach(tag => {
              //   meta_tags['tags'][tag] = instance[tag];
              // });
            }

            meta_tags['file_meta']['TransferSyntaxUID'] =
              instance['_meta']['TransferSyntaxUID']['Value'][0];

            // console.log('tsx UID:', meta_tags['TransferSyntaxUID']);

            var json = JSON.stringify(meta_tags); //Convert JSON Array to string.
            json = [json]; //Convert JSON string to BLOB.

            // console.log('json:', json);

            var tags_blob = new Blob(json, {
              type: 'text/plain;charset=utf-8',
            });

            zip.file(`${instance.SOPInstanceUID}.json`, tags_blob);
            foundImportant = true;
          });
        }
      });

      if (foundImportant) {
        console.log('found important, zipping');
        sendSessionName();

        const psc = { presharedCode: presharedCode };

        var json = JSON.stringify(psc); //Convert JSON Array to string.
        json = [json]; //Convert JSON string to BLOB.
        var psc_blob = new Blob(json, { type: 'text/plain;charset=utf-8' });

        zip.file('preshared_code.json', psc_blob);

        zip
          .generateAsync({ type: 'blob' }, function updateCallback(metadata) {
            setProgress(Math.round(metadata.percent));
          })
          .then(function(blob) {
            console.log('zip done, upload blob');
            setProgressText(`uploading study ...`);
            // downloadBlob(blob).then(function() {
            uploadBlob(blob).then(function() {
              DicomMetadataStore.updateInferenceInProgress(
                study.StudyInstanceUID,
                true
              );
              DicomMetadataStore.setProgressValue(
                study.StudyInstanceUID,
                undefined
              );
              DicomMetadataStore.updateProgressText(
                study.StudyInstanceUID,
                'connecting to backend...'
              );
              console.log('resolve');
              resolve(1);
            });
          });
      } else {
        console.log('reject in zipAll');
        reject('important not found');
      }
    });
  }

  useEffect(() => {}, [showLoadingIndicator]); //, progress, progressText]);
  // progress, progresstext nem kell, mert a komponens re-renderelődik, ha egy property változik
  // csak saját maga (UploadForm) rerendereléséhez kell useEffect

  const studyUIDs = DicomMetadataStore.getStudyInstanceUIDs();
  const study = DicomMetadataStore.getStudy(studyUIDs[0]);
  if (!study.inferable) {
    return (
      <div>
        <Typography variant="h6">{t('Analysis not possible')}</Typography>

        <div className="flex flex-col mt-6">
          <div>reason: {study.problems}</div>
        </div>
      </div>
    );
  } else {
    return (
      <div>
        <Typography variant="h6">
          {t('Upload anonymized data to OrthoPred server')}
        </Typography>

        <div className="flex flex-col mt-6">
          <div>
            {showLoadingIndicator && (
              <LoadingIndicatorProgress
                className="h-full w-full"
                textBlock={progressText}
                progress={progress}
                indicatorStyle={{ width: '24em' }}
              />
            )}
          </div>
        </div>
        <div className="w-1/2 mb-4">
          <Input
            data-cy="file-name"
            value={presharedCode}
            onChange={evt => checkValue(evt.target.value)}
            onKeyDown={handleKeyDown}
            label={t(
              'Enter an identification code. Based on this code later you can find the results in the archive. If you leave field empty, results will not be archived.'
            )}
            autoFocus
          />
        </div>
        <div className="mt-8"></div>

        {/* a gombok csak akkor aktívak, ha a LoadingIndicatorProgress nem !!! */}

        <div className="flex justify-end mt-4">
          <Button
            data-cy="cancel-btn"
            variant="outlined"
            size="initial"
            color="black"
            border="secondary"
            onClick={onClose}
            className="p-2"
          >
            {t('Cancel')}
          </Button>
          <Button
            className="ml-2"
            onClick={uploadStudy}
            color="primary"
            data-cy="download-btn"
          >
            {t('Upload')}
          </Button>
        </div>
      </div>
    );
  }
};

export default UploadForm;
